import config from '../config';

function getIconUrl(icon: string): Record<string, string> {
    return { [icon]: `${config.domain}/${config.iconsFolder}/${icon}.svg` };
}

export type BridgeWarIcons = Record<string, string>;

export const bridgeWarIcons: BridgeWarIcons = {
    ...getIconUrl('attacker'),
    ...getIconUrl('compass'),
    ...getIconUrl('defender'),
    ...getIconUrl('diamondFull'),
    ...getIconUrl('diamondOutline'),
    ...getIconUrl('east'),
    ...getIconUrl('north'),
    ...getIconUrl('rank_1'),
    ...getIconUrl('rank_2'),
    ...getIconUrl('rank_3'),
    ...getIconUrl('south'),
    ...getIconUrl('west'),
};
